<template>
  <a-modal
    centered
    class="add-timesheet-modal"
    :visible="visible"
    :title="$t('dashboard.modal.edit_timesheet')"
    :footer="null"
    @ok="handleOk"
    @cancel="handleCancel"
    :destroyOnClose="true"
  >
    <CreateAdditionalTimesheet
      @cancel="handleFormCancel"
      @ok="handleFormOk"
      :work_date="workDate"
    />
  </a-modal>
</template>
<script>
import moment from "moment";
import CreateAdditionalTimesheet from "../CreateAdditionalTimesheet.vue";
export default {
  name: "AddAdditionalTimesheetModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    workDate: {
      type: String,
    },
  },
  components: {
    CreateAdditionalTimesheet,
  },
  watch: {
    workDate() {},
  },
  data() {
    return {
      requestData: moment(),
      dateFormat: "DD/MM/YYYY",
    };
  },
  methods: {
    handleOk() {
      this.$emit("ok");
    },
    handleCancel(e) {
      this.$emit("cancel", e);
    },
    handleFormCancel(e) {
      this.handleCancel(e);
    },
    handleFormOk(e) {
      this.handleOk(e);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .ant-modal-mask {
  z-index: 1030;
}
/deep/ .ant-modal-wrap {
  z-index: 1030;
  &::-webkit-scrollbar {
            display: none;
        }
}
</style>
<style lang="scss">
.add-timesheet-modal {
  .ant-modal-header {
    padding: 16px 24px;
    color: rgba(0, 0, 0, 0.65);
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    border-radius: 10px 10px 0 0;
    background-color: #d2d6ff;
    border-bottom-color: #3d4cdc;
    .ant-modal-title {
      color: #3d4cdc;
    }
  }
  .ant-modal {
    width: 100% !important;
    max-width: 684px;
  }
    .ant-modal-content {
    border-radius: 10px;
  }
  .ant-modal-close {
    outline: unset !important;
  }
  .ant-modal-close-x {
       line-height: 48px;
  }

}
   /deep/ .ant-modal-content {
    position: relative;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-radius: 10px;
    // box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
    pointer-events: auto;
   }
</style>